<template>
  <section class="bg-women-shade py-10">
    <div class="max-w-900">
      <div class="px-4 md:text-center text-women-text">
        <p class="o-heading-2 mb-3 md:text-center" v-text="title" />
        <p class="o-body mb-3" v-html="description" />
      </div>
      <div class="pt-6 text-women-text">
        <div
          ref="scrollContainer"
          class="flex overflow-x-scroll disable-scrollbars horizontal-scroll pr-6 md:pr-0"
          tabindex="0"
          role="region"
          aria-label="How it works steps"
          @keydown.left="scrollLeft"
          @keydown.right="scrollRight"
        >
          <article
            v-for="slide in howItWorksSlides"
            :key="slide.title"
            class="pl-6 flex-1 horizontal-scroll-center"
          >
            <div class="rounded-t">
              <OSvg :svg="slide.svg" />
              <p class="text-center o-heading-5 mb-6" v-html="slide.title" />
              <p class="text-center o-body" v-html="slide.description" />
            </div>
          </article>
        </div>
      </div>
      <div v-if="atcText" class="text-center pt-6 md:pt-9">
        <NewButton tag="nuxt-link" to="/women/signup" icon-right="new-chevron-right" color="white">
          {{ atcText }}
        </NewButton>
      </div>
    </div>
  </section>
</template>

<script>
import OSvg from '@/components/OSvg'
import NewButton from '@/components/NewButton'

export default {
  name: 'WomenHowItWorks',
  components: { OSvg, NewButton },
  props: {
    howItWorksSlides: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    atcText: {
      type: String,
      default: ''
    }
  },
  methods: {
    scrollLeft () {
      if (this.$refs.scrollContainer) {
        this.$refs.scrollContainer.scrollLeft -= 200 // Adjust scroll amount as needed
      }
    },
    scrollRight () {
      if (this.$refs.scrollContainer) {
        this.$refs.scrollContainer.scrollLeft += 200 // Adjust scroll amount as needed
      }
    }
  }
}
</script>

<style scoped lang="postcss">
.max-w-900 {
  @apply mx-auto;
  max-width: 90rem;
}

/* Add visual indication of focus */
.horizontal-scroll:focus {
  outline: 2px solid #36C0B6; /* Use your primary color */
  outline-offset: -2px;
}

/* Add scrollbar styling for visual users */
.horizontal-scroll {
  scroll-behavior: smooth; /* For smooth scrolling */
}
</style>
